<template>
    <Dialog 
          :header="formMode == 'edit' ? 'Chỉnh sửa lý do': 'Tạo mới lý do'"
          :visible.sync="displayDialog"
          :contentStyle="{overflow: 'visible'}"
          :style="{width: '50vw'}"
          :class="'popup-dialog'"
          :modal="true"
        >
        <div class="p-fluid">
            <div class="p-col-12 form-popup-custom">
                <div class="p-field">
                    <label>Mã lý do <span class="error">*</span></label>
                </div>
                <div class="p-field">
                    <InputText disabled="true" id="code" type="text" v-model="code" :placeholder="'Nhập mã lý do'"/>
                </div>
            </div>

            <div class="p-col-12 form-popup-custom">
                <div class="p-field">
                    <label>Lý do <span class="error">*</span></label>
                </div>
                <div class="p-field">
                    <InputText maxlength="255" id="name" type="text" v-model="name" :placeholder="'Nhập lý do'"/>
                    <small v-if="validationErrors && validationErrors['name']"
                        class="p-invalid" >{{validationErrors['name']}}</small>
                </div>
            </div>

            <div class="p-col-12 form-popup-custom">
                <div class="p-field">
                    <label>Loại lý do <span class="error">*</span></label>
                </div>
                <div class="p-field">
                    <Dropdown  v-model="reason_type" :options="reasonTypes" optionLabel="name" optionValue="value" placeholder="Chọn loại" />
                    <small v-if="validationErrors && validationErrors['reason_type']"
                        class="p-invalid" >{{validationErrors['reason_type']}}</small>
                </div>
            </div>

            <div class="p-col-12 form-popup-custom">
                <div class="p-col-12 p-grid">
                    <div class="p-col-6">
                        <div class="p-field">
                                <label >Thứ tự hiển thị</label>
                                <div class="input-number-inline">
                                    <InputNumber :min="-1"  id="ordering" v-model="ordering" showButtons />
                                </div>
                        </div>
                    </div>
                    <div class="p-col-6 align-items" v-if="reason_type == 'not_accepted'">
                        <div class="p-field">
                            <div class="p-field-checkbox">
                                <Checkbox  v-model="is_change_product" :binary="true"/>
                                <label >Đổi sản phẩm</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="p-col-12 form-popup-custom">
                <div class="p-col-12 p-grid">
                    <div class="p-col-6">
                        <div class="p-field">
                            <div class="p-field-checkbox">
                                <Checkbox  v-model="is_add_note" :binary="true"/>
                                <label >Nhập thêm nội dung</label>
                            </div>
                        </div>
                    </div>
                    <div class="p-col-6 align-items">
                        <div class="p-field">
                            <div class="p-field-checkbox">
                                <Checkbox  v-model="status" :binary="true"/>
                                <label >Hiển thị sử dụng</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
        <template #footer>
            <Button :disabled="submitForm" class="p-button-success"  :label="formMode == 'edit' ? 'Lưu' : 'Tạo'" @click="saveData" />
        </template>
      </Dialog>
</template>

<script>
import DataServices from '@/core/DataServices'

export default {
  props: {
    show: Boolean,
    mode: String,
    modelName: String,
    model: Object
  },
  data() {
    return {
        code: '',
        name: '',
        reason_type: {},
        reasonTypes: [
            {name: 'Đổi sản phẩm', value: 'warranty_discontinuation'},
            {name: 'Trả sản phẩm', value: 'return_product'},
            {name: 'Không nghiệm thu', value: 'not_accepted'},
        ],
        is_add_note: false,
        is_change_product: false,
        status: true,
        displayDialog: this.show,
        validationErrors: {},
        code_exists: false,
        submitForm: false,
        ordering: 1
    }
  },
  created() {
    this.formMode = this.mode;
    if (this.formMode === 'edit' && this.model !== undefined && this.model !== null && Object.entries(this.model).length) {
      this.code = this.model.code;
      this.name = this.model.reason_name;
      this.status = this.model.status > 0;
      this.is_add_note = this.model.is_add_note;
      this.is_change_product = this.model.is_change_product;
      this.reason_type = this.model.reason_type;
      this.ordering = (this.model.ordering != undefined && this.model.ordering != null) ? this.model.ordering :  0;
    }
  },
  methods: {
    async validateData() {
        this.validationErrors = {};
        // if (this.code === undefined || this.code === "") this.validationErrors['code'] = 'Nhập mã lý do';
        if (this.name === undefined || this.name === "") this.validationErrors['name'] = 'Nhập lý do';
        if (this.reason_type === undefined || this.reason_type === "" || this.reason_type == null || Object.keys(this.reason_type).length == 0) this.validationErrors['reason_type'] = 'Vui lòng chọn loại lý do';
        this.code_exists = await this.checkCode();
    },
    async checkCode() {
        this.code = this.code.trim();
        this.name = this.name.trim();
        if (this.code !== undefined && this.code !== "") {
            if (this.formMode === 'add' || (this.formMode === 'edit' && this.code !== this.model.code)) {
                var where = { code: {'_ilike': this.code} }
                var data = await DataServices.getList(this.modelName, {"fields": "code", "variables": JSON.stringify({where_key: where})});
                return data && data[Object.keys(data)].length > 0
            }
        }
    },
    async getCode() {
        var number = 1;
        var variables = {
            where_key: {
                reason_type: {'_eq': this.reason_type },
                status: {'_in': [0, 1]}
            },
            orderBy: {
                id: 'desc'
            },
            limit: 1
        }
        var data = await DataServices.getList('setting_reason_reject', {"variables": JSON.stringify(variables), 'fields': 'code'});
        var list = data[Object.keys(data)];
        if (list != null && Object.keys(list).length > 0) {
            var code = list[0].code;
            code = code.substring(3);
            number += parseInt(code);
        }
        if (this.reason_type === 'warranty_discontinuation') return 'BH' + this.$myConstants.autoGenerateZero(number);
        else if (this.reason_type === 'not_accepted') return 'NT' + this.$myConstants.autoGenerateZero(number);
    },
    async getCodeNext(reason_type) {
      var firstCode = '';
      if (reason_type == 'warranty_discontinuation'){
        firstCode = 'DSP';
      }else if (reason_type === 'return_product'){
        firstCode = 'TSP';
      }else if (reason_type === 'not_accepted'){
        firstCode = 'KNT';
      }
      //tìm code cuối cùng || loại trừ trường hợp chọn reason_type xong đổi sang loại khác
      var where = {
        code: {_like: "%"+firstCode+"%"}
      };
      var data =await DataServices.getObjectData('setting_reason_reject',where,{id: 'desc'});
      if (!this.$myConstants.isEmpty(data)){
        var codeLast = data.code;
        var codeRightLast = codeLast.substring((codeLast.length - 4));//Cắt lấy 6 ký tự cuối cùng
        var codeRightTmp =(parseInt(codeRightLast) + 1).toString();
        return firstCode+codeRightTmp.padStart(4, '0');
      }
      return firstCode+'0001';
    },
    async saveData() {
        this.submitForm = true;
        await this.validateData();
        if (!this.code_exists && Object.entries(this.validationErrors).length === 0) {
            if (this.formMode === 'add') this.code = await this.getCodeNext(this.reason_type);
            if (this.code.length > 0) {
                var params = {
                    'code': this.code,
                    'ordering': this.ordering,
                    'reason_name': this.name,
                    'is_add_note': this.is_add_note,
                    'reason_type': this.reason_type,
                    'is_change_product': this.is_change_product,
                    'status': this.status ? 1 : 0
                }
                //default is_change_product cho nếu flow cũ
                if (this.reason_type == 'warranty_discontinuation'){
                  params.is_change_product = true;//nếu đổi sản phẩn defaukt true
                }else if (this.reason_type == 'return_product'){
                  params.is_change_product = false;//nếu trả sp default false
                }
                if (this.formMode === 'add') {
                    params = Object.assign(params, { 'modified_date': this.$myConstants.currentDate() })
                    params = Object.assign(params, { 'created_date': this.$myConstants.currentDate() })
                    await DataServices.insertData(this.modelName, {"variables": JSON.stringify({objects: params})});
                    this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Tạo mới thành công', life: 3000 })
                    this.displayDialog = false;
                    this.$emit('refresh');
                } else {
                    params = Object.assign(params, { 'modified_date': this.$myConstants.currentDate() })
                    await DataServices.updateData(this.modelName, {"variables": JSON.stringify({data_update: params, where_key: { code: {'_eq': this.model.code }}})});
                    this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Cập nhật thành công', life: 3000 })
                    this.displayDialog = false;
                    this.$emit('refresh');
                }
            }
        } else this.submitForm = false;
    }
  }
}
</script>

<style lang="scss" scoped>
</style>